<div class="row">
	<div class="col-sm-12">
		<app-owner-list-filters
			#listfilters
			[searchparams]="advancedSearch"
			[companyid]="companyid">
		</app-owner-list-filters>

	</div>
	<div class="col-sm-12">
		<app-card
			[hidHeader]="true"
			cardClass="card-datatable"
			[options]="false">

			<a
				class="float-right btn btn-sm btn-primary"
				(click)="edit()">
				<i
					container="body"
					ngbTooltip="{{'labels.create' | translate}}"
					class="feather icon-plus"></i>
			</a>

			<div class="table-responsive">

				<ngx-datatable
					[tablefix]="datatable"
					#datatable
					class="bootstrap"
					[rows]="rows"
					[columnMode]="'flex'"
					[rowHeight]="'auto'"
					[headerHeight]="50"
					[footerHeight]="30"
					[externalPaging]="true"
					[externalSorting]="true"
					[loadingIndicator]="loading"
					[count]="page.totalElements"
					[offset]="page.pageNumber"
					[limit]="page.size"
					[rowClass]="rowClass"
					(page)="onPageChange($event)"
					(sort)="onSortChange($event)"
					(activate)="onActivate($event)"
					[messages]="{
          emptyMessage: 'labels.empty-owners' | translate,
          totalMessage: 'labels.total' | translate
		}">
					<ngx-datatable-column
						prop="id"
						[flexGrow]="0.5"
						[name]="'labels.id' | translate"
						[resizeable]="false">
						<ng-template
							let-value="value"
							let-row="row"
							ngx-datatable-cell-template>
							<a
								routerLink="/company/owner/view/{{row.id}}"
								class="link"
								ngbTooltip="{{'labels.details' | translate}}">
								{{value}}
							</a>
						</ng-template>
					</ngx-datatable-column>

					<ngx-datatable-column
						prop="fname"
						[flexGrow]="2"
						[name]="'labels.fname' | translate"
						[resizeable]="false">
						<ng-template
							let-value="value"
							let-row="row"
							ngx-datatable-cell-template>
							<a
								routerLink="/company/owner/view/{{row.id}}"
								class="link"
								ngbTooltip="{{'labels.details' | translate}}">
								{{value}}
							</a>
						</ng-template>
					</ngx-datatable-column>

					<ngx-datatable-column
						prop="lname"
						[flexGrow]="2"
						[name]="'labels.lname' | translate"
						[resizeable]="false">
						<ng-template
							let-value="value"
							let-row="row"
							ngx-datatable-cell-template>
							{{value}}
						</ng-template>
					</ngx-datatable-column>

					<ngx-datatable-column
						prop="mgmttype"
						[flexGrow]="2"
						[name]="'labels.mgmttype' | translate"
						[resizeable]="false">
						<ng-template
							let-value="value"
							let-row="row"
							ngx-datatable-cell-template>
							{{value}}
						</ng-template>
					</ngx-datatable-column>

					<ngx-datatable-column
						prop="docvalid"
						[flexGrow]="0.5"
						[name]="''"
						[resizeable]="false">
						<ng-template
							let-value="value"
							ngx-datatable-cell-template>
							<i
								*ngIf="value"
								container="body"
								ngbTooltip="{{'labels.docvalid' | translate}}"
								class="icon-valid feather icon-check-circle"></i>

							<i
								*ngIf="!value"
								container="body"
								ngbTooltip="{{'labels.docinvalid' | translate}}"
								class="icon-invalid feather icon-alert-octagon"></i>
						</ng-template>
					</ngx-datatable-column>
					<ngx-datatable-column
						prop="birthdate"
						[flexGrow]="1.5"
						[name]="'labels.birthdate' | translate"
						[resizeable]="false">
						<ng-template
							let-value="value"
							ngx-datatable-cell-template>
							{{value | date: 'dd/MM/yyyy' }}
						</ng-template>
					</ngx-datatable-column>

					<ngx-datatable-column
						prop="cf"
						[flexGrow]="2"
						[name]="'labels.cf' | translate"
						[resizeable]="false">
						<ng-template
							let-value="value"
							let-row="row"
							ngx-datatable-cell-template>
							{{value}}
						</ng-template>
					</ngx-datatable-column>

					<ngx-datatable-column
						prop="email"
						[flexGrow]="2"
						[name]="'labels.email' | translate"
						[resizeable]="false">
						<ng-template
							let-value="value"
							let-row="row"
							ngx-datatable-cell-template>
							{{value}}
						</ng-template>
					</ngx-datatable-column>

					<ngx-datatable-column
						[flexGrow]="1"
						[sortable]="false"
						[resizeable]="false"
						[cellClass]="'text-center'">
						<ng-template
							let-value="value"
							let-row="row"
							ngx-datatable-cell-template>
							<div class="icon-buttons">

								<a
									(click)="edit(row.id)"
									class="link">
									<i
										container="body"
										ngbTooltip="{{'labels.edit' | translate}}"
										class="feather icon-edit"></i>
								</a>
								<a
									(click)="delete(row, $event)"
									class="link">
									<i
										container="body"
										ngbTooltip="{{'labels.delete' | translate}}"
										class="feather icon-trash"></i>
								</a>

							</div>
						</ng-template>
					</ngx-datatable-column>
				</ngx-datatable>
			</div>
		</app-card>
	</div>
</div>
